import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import './index.css';
// import Particles from './Components/Particles';
// import MoltenMetal from './Components/MoltetMetal';
// import AnimatedContent from './Components/AnimatedContent';
import OrbitalSphereBackground from "./Components/OrbitalSphere/OrbitalSphereBackground"

import FadeContent from './Components/FadeContent';
import Admin from './Pages/Admin/Admin';

const Main = lazy(() => import('./Pages/Main/Main'));
// import Main from './Pages/Main/Main';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <div style={{ width: '100%', height: '100%', position: 'relative', display: 'flex', justifyContent: 'center' }}>
            {/* <Particles
                particleColors={['#ff5500', '#ffa200']}
                particleCount={600}
                particleSpread={10}
                speed={0.1}
                particleBaseSize={150}
                moveParticlesOnHover={false}
                disableRotation={false}
            /> */}
            {/* <MoltenMetal
                color1="#c35f15"
                color2="#ff6000"
                color3="#FFFFFF"
                colorMode="molten"
                speed={0.25}
                scale={6}
                detail={3}
                glow={2.05}
                coreSize={0.13}
                swirl={1}
                fold={-0.31}
                blackPoint={0.12}
                brightness={1.3}
                opacity={1}
                grain={false}
                grainIntensity={0.05}
                mouseInteraction={false}
                mouseStrength={0.3}
            /> */}
            <OrbitalSphereBackground speed={1} hue={110} />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={
                        <FadeContent
                            // distance={100}
                            // direction="vertical"
                            // reverse={true}
                            // duration={2}
                            // ease="power3.out"
                            // initialOpacity={0}
                            // scale={0.5}
                            // delay={1}
                            // blur={true} 
                            duration={1000} 
                            easing="ease-out" 
                            initialOpacity={0}
                            delay={0.5}
                        >
                            <Suspense>
                                <Main />
                            </Suspense>
                        </FadeContent>
                    } />
                    <Route path="/admin/" element={<Admin />} />

                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </BrowserRouter>
            
        </div>
    </React.StrictMode>
);
